import { entities } from 'pages/store/schema';
import { getValues } from 'pages/store/selectors';

export const getPreAuthorizationEmails = (state) =>
  getValues(entities.preAuthorizationEmail)(state) || [];
